import moment from 'moment';

export default (startDate, days) => {
  const start = moment(startDate);
  const end = moment(startDate).add(days - 1, 'days');

  if (days === 1) {
    return `${start.format('MMM D, YYYY')}`;
  }

  return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
};



// WEBPACK FOOTER //
// ./src/subscription/coaching/golf-schools/formatClassDateRange.js